<template>
  <div>
    <div
      class="home-contact has-background-alt-blue p-t-xl p-b-xl p-l-md p-r-md is-relative"
    >
      <div class="container">
        <div class="columns">
          <div class="column contact">
            <div class="has-text-white">
              <h2 class="has-text-weight-bold is-size-3">Contáctanos</h2>
              <address class="m-b-lg m-t-md">
                <div class="has-text-weight-bold">Oficina principal</div>
                <div>Justo Sierra #2550 Esquina Victoriano Salado Álvarez</div>
                <div>Col. Ladrón de Guevara</div>
                <div>Guadalajara, Jalisco</div>
                <div class="m-t-md">
                  <vue-fontawesome icon="phone-alt" />
                  <div
                    class="has-text-secondary has-text-weight-medium is-inline"
                  >
                    <a href="tel:3330408700" class="phone m-l-md"
                      >(33) 3040-8700</a
                    >
                  </div>
                </div>
              </address>
              <address>
                <div class="has-text-weight-bold">Ventas y Rentas Plus</div>
                <div>Justo Sierra #2541 Int. 6</div>
                <div>Col. Ladrón de Guevara</div>
                <div>Guadalajara, Jalisco</div>
                <div class="m-t-md">
                  <span class="has-text-weight-bold m-l-md">Rentas plus</span>
                </div>
                <div class="m-l-md has-text-secondary has-text-weight-medium">
                  <vue-fontawesome icon="phone-alt" />
                  <a href="tel:3330449900" class="phone m-l-md"
                    >(33) 3044-9900</a
                  >
                </div>
              </address>
              <div class="m-t-md m-l-md">
                <div class="has-text-weight-bold">Ventas</div>
                <div has-text-secondary has-text-weight-medium>
                  <vue-fontawesome icon="phone-alt" />
                  <a href="tel:3336156905" class="phone m-l-md">
                    (33) 3615-6905
                  </a>
                  <a href="tel:3336155612" class="phone m-l-sm">
                    (33) 3615-5612
                  </a>
                  <a href="tel:3336156917" class="phone m-l-sm">
                    (33) 3615-6917
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <contact-form />
          </div>
          <img
            class="is-hidden-mobile house-outline"
            src="@/assets/icons/house-outline.svg"
            alt="house outline"
          />
        </div>
      </div>
    </div>
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1700.5135880823998!2d-103.38181911157592!3d20.678462995513218!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x976a534489546eef!2sCasa%20Administraciones!5e0!3m2!1sen!2smx!4v1583100623142!5m2!1sen!2smx"
      width="100%"
      frameborder="0"
      style="border:0; height: 400px;"
      allowfullscreen=""
      title="MapDirection"
    ></iframe>
  </div>
</template>

<script>
import ContactForm from "@/components/ContactForm";

export default {
  name: "MainContact",

  components: {
    ContactForm
  }
};
</script>

<style lang="scss" scoped>
.contact {
  position: relative;
  z-index: 10;
}

.phone,
.phone:active,
.phone:focus {
  color: #daeeff !important;
  text-decoration: underline;
}

.house-outline {
  position: absolute;
  left: 50%;
  margin-left: -330px;
  bottom: -3em;
  z-index: 5;
}

address {
  font-style: inherit;
}
</style>
